import styled from 'styled-components';
import { size } from '../../../../styled-components/layout/helpers';
import { ButtonReset } from '../../../../styled-components/layout/reset';

export const FakeSearchBar = styled(ButtonReset)`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${size(1.5)};
  width: 300px;
  height: ${size(5)};
  padding-inline: ${size(2)};
  background-color: var(--c-global-search-bg);
  color: var(--c-global-search-fg);
  border-radius: 100vmax;
  text-align: left;
  border: 1px solid transparent;
  cursor: text;

  &:hover {
    border-color: var(--c-border-main);
  }

  svg {
    display: block;
  }

  ${(props) => props.theme.breakpoint.LtMd} {
    width: 100%;
  }
`;

export const Placeholder = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${size(1.5)};
  color: var(--c-text-muted);
  font-size: ${(props) => props.theme.font.size.small};
`;

export const Shortcut = styled.span`
  display: block;
  font-size: ${(props) => props.theme.font.size.xsmall};

  kbd {
    font: inherit;
  }

  ${(props) => props.theme.breakpoint.LtSm} {
    display: none;
  }
`;
